import { socket } from "../index";

interface ListenReceiveResponseCreateRoomPayload {
  success: boolean,
  roomId: string | null,
  errorMessage: string | null,
}

const listenReceiveResponseCreateRoom = () => {
  socket?.on('RECEIVE_RESPONSE_CREATE_ROOM', (payload: ListenReceiveResponseCreateRoomPayload) => {
    if (payload.success) {
      window.location.href = `/chatting-app/room/${payload.roomId}`;
    }
  });
}

export default listenReceiveResponseCreateRoom;